import { COLORS, RADIUS } from "../../shared/theme";

export function FieldGroup({ label, children }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label
        style={{
          display: "block",
          fontSize: 11,
          fontWeight: 700,
          color: COLORS.textSecondary,
          marginBottom: 4,
          textTransform: "uppercase",
          letterSpacing: "0.06em",
        }}
      >
        {label}
      </label>
      {children}
    </div>
  );
}

export function Input({ value, onChange, type = "text", placeholder }) {
  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      style={{
        width: "100%",
        padding: "7px 10px",
        borderRadius: RADIUS.sm,
        border: `1.5px solid ${COLORS.border}`,
        fontSize: 13,
        color: COLORS.textPrimary,
        background: COLORS.white,
        outline: "none",
        fontFamily: "inherit",
        boxSizing: "border-box",
      }}
      onFocus={e => (e.target.style.borderColor = COLORS.primaryAccent)}
      onBlur={e => (e.target.style.borderColor = COLORS.border)}
    />
  );
}

export function SelectField({ value, onChange, options }) {
  return (
    <select
      value={value}
      onChange={onChange}
      style={{
        width: "100%",
        padding: "7px 10px",
        borderRadius: RADIUS.sm,
        border: `1.5px solid ${COLORS.border}`,
        fontSize: 13,
        color: COLORS.textPrimary,
        background: COLORS.white,
        outline: "none",
        fontFamily: "inherit",
        boxSizing: "border-box",
        cursor: "pointer",
      }}
    >
      {options.map(o => (
        <option key={o.value ?? o} value={o.value ?? o}>
          {o.label ?? o}
        </option>
      ))}
    </select>
  );
}

export function Textarea({ value, onChange, placeholder, rows = 3 }) {
  return (
    <textarea
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      style={{
        width: "100%",
        padding: "7px 10px",
        borderRadius: RADIUS.sm,
        border: `1.5px solid ${COLORS.border}`,
        fontSize: 13,
        color: COLORS.textPrimary,
        background: COLORS.white,
        outline: "none",
        fontFamily: "inherit",
        boxSizing: "border-box",
        resize: "vertical",
      }}
      onFocus={e => (e.target.style.borderColor = COLORS.primaryAccent)}
      onBlur={e => (e.target.style.borderColor = COLORS.border)}
    />
  );
}

export function Row({ label, val }) {
  if (!val) return null;

  return (
    <div style={{ display: "flex", gap: 6, marginBottom: 5, fontSize: 11 }}>
      <span style={{ color: COLORS.textMuted, minWidth: 68, flexShrink: 0 }}>{label} :</span>
      <span style={{ color: COLORS.textPrimary, fontWeight: 500 }}>{val}</span>
    </div>
  );
}
